import { HttpAgent } from '@ag-ui/client';
import { withPepperHeaders } from '@/experiences/sales-portal/domain/superintelligence/blocs/services/agent-headers';

export type AgentFetch = NonNullable<
  ConstructorParameters<typeof HttpAgent>[0]['fetch']
>;

export const agentFetch: AgentFetch = async (url, init) =>
  fetch(url, await withPepperHeaders(init));
